import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  // 支付二维码状态轮询
  getTransactionCode: (params: { code: string }) => {
    return defHttp.get<{ status: string; tradeNo?: string }>({
      url: '/aiad/qr-code',
      params,
    });
  },

  // 创建支付 code（灵豆 sku / 存储扩容）
  transactionCode: (params: {
    skuId?: number;
    tradeNo?: string;
    capacityGB?: number;
    months?: number;
  } & Record<string, any>) => {
    return defHttp.post<string>({
      url: '/aiad/qr-code',
      params,
    });
  },
});
